import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import timeStampToDate from '@/helpers/timeStampToDate';
import URLRenderer from '@/app/common/components/CellRenderers/URLRenderer';
import { getColor } from '@/helpers/utils';
import { useDispatch } from 'react-redux';
import { showCannibalizationsModal } from '@/app/KeywordTracker/reducers/cannibalizationsModal';
import RankRenderer from '@/app/common/components/CellRenderers/RankRenderer';
import RankChangeRendererNew from '@/app/common/components/CellRenderers/RankChangeRendererNew';
import { dateFilterGetter } from '@/app/common/components/ag-grid/configs';
import SmallButton from '@/app/common/components/SmallButton';

export const rankHistoryColumnConfig = [
  {
    searchable: true,
    field: 'updated_at',
    type: 'string',
    title: 'تاریخ به‌روزرسانی',
    width: 150,
    valueGetter: dateFilterGetter
    // cellRenderer: params => <>{timeStampToDate(params.value)?.slice(8)}</>
  },
  {
    field: 'rank',
    type: 'number',
    title: 'رتبه',
    width: 130,
    searchable: true,
    cellRenderer: params => <RankRenderer rank={params.value} />
  },
  {
    field: 'change_rank',
    type: 'number',
    title: 'تغییر رتبه',
    width: 100,
    searchable: true,
    cellRenderer: params => <RankChangeRendererNew rank={params.data.rank} previous_rank={params.data.previous_rank} change={params.value} />
  },
  {
    searchable: true,
    field: 'cannibalizations',
    type: 'string',
    title: 'همنوع خواری',
    width: 130,
    useValueFormatterForExport: true,
    cellRenderer: params => {
      const dispatch = useDispatch();
      return (
        params.value.length > 0 && (
          <div className="d-flex h-100 align-items-center justify-content-center">
            <SmallButton
              onClick={() => {
                dispatch(
                  showCannibalizationsModal({
                    keyword: params.data.keyword,
                    data: params.value
                  })
                );
              }}
            >
              <svg
                height="0.7em"
                width="0.7em"
                fill="var(--falcon-btn-falcon-primary-color)"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                x="0px"
                y="0px"
                viewBox="0 0 24 24"
                enableBackground="new 0 0 24 24"
              >
                <g>
                  <g>
                    <path d="M19.1,4.9C17.3,3.1,14.8,2,12,2C9.2,2,6.7,3.1,4.9,4.9S2,9.2,2,12s1.1,5.3,2.9,7.1S9.2,22,12,22    c2.8,0,5.3-1.1,7.1-2.9L12,12L19.1,4.9z M10.5,8C9.7,8,9,7.3,9,6.5C9,5.7,9.7,5,10.5,5S12,5.7,12,6.5C12,7.3,11.3,8,10.5,8z"></path>
                  </g>
                  <g>
                    <circle cx="20" cy="12" r="2"></circle>
                  </g>
                </g>
              </svg>
            </SmallButton>
          </div>
        )
      );
    }
  },
  {
    searchable: true,
    field: 'found_url',
    type: 'string',
    title: 'صفحه پیدا شده',
    flex: 1,
    cellRenderer: params =>
      params.value && (
        <div className="d-flex align-items-center gap-2">
          <URLRenderer url={params.value} />
        </div>
      )
  }
];
